import { JsonPipe, NgClass } from '@angular/common';
import { Component, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { TransContent } from 'src/app/core/models/trans-content';


@Component({
    selector: 'app-content-translater',
    templateUrl: './content-translater.component.html',
    styleUrls: ['./content-translater.component.scss'],
    standalone: true,
    imports: [NgClass]
})
export class ContentTranslaterComponent implements OnInit, OnDestroy {
  @Input() content: TransContent;
  @Input() selectedLang?: string;
  @Input() notBold?: boolean = false;
  public currentLang;
  public subscription = new Subscription;
  constructor(private translateService: TranslateService) { }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit() {
    if(!this.selectedLang) {
      this.currentLang = this.translateService.currentLang
      let sub = this.translateService.onLangChange.subscribe(result => {
        this.currentLang = result.lang;
      })
      this.subscription.add(sub);
    }
     else {
      this.currentLang = this.selectedLang;
    }

  }
    ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedLang'] && !changes['selectedLang'].firstChange) {
      this.currentLang = this.selectedLang;
    }
  }
}
